<template>
  <div>
    <div
      class="tw-flex tw-items-center tw-space-x-3 tw-text-sm sm:tw-text-base"
    >
      <div
        :class="[
          modelValue === leftBillingCycle
            ? 'tw-font-medium'
            : 'tw-text-neutral-500',
        ]"
      >
        <span class="tw-capitalize">{{ leftBillingCycle }}</span>
      </div>
      <FormToggle
        v-model="isToggleActive"
        size="small"
        test_id="billing-cycle-toggle"
      />
      <div
        :class="[
          modelValue === rightBillingCycle
            ? 'tw-font-medium'
            : 'tw-text-neutral-500',
        ]"
      >
        <span class="tw-capitalize">{{
          rightBillingCycle === BILLING_CYCLES.ANNUALLY
            ? 'Yearly'
            : rightBillingCycle
        }}</span>
        <span
          v-if="
            rightBillingCycle === BILLING_CYCLES.ANNUALLY && !annualBonusHidden
          "
          class="tw-ml-1 tw-hidden sm:tw-inline-block"
        >
          - {{ $page.props.content.toggleYearlyText }}
        </span>
      </div>
    </div>

    <div
      v-if="modelValue === BILLING_CYCLES.ANNUALLY && !annualBonusHidden"
      class="tw-mt-4 tw-text-sm sm:tw-hidden"
    >
      Bonus: {{ $page.props.content.toggleYearlyText }}
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import FormToggle from '@/shared/components/forms/FormToggle.vue'

const BILLING_CYCLES = {
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  ANNUALLY: 'annually',
}
const BILLING_CYCLES_PRIORITIES = {
  [BILLING_CYCLES.MONTHLY]: 1,
  [BILLING_CYCLES.QUARTERLY]: 2,
  [BILLING_CYCLES.ANNUALLY]: 3,
}

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  annualBonusHidden: {
    type: Boolean,
    default: false,
  },
  billingCycles: {
    type: Array,
    required: true,
  },
})
const emit = defineEmits(['update:modelValue'])

const sortedBillingCycles = computed(() =>
  [...props.billingCycles].sort(
    (a, b) => BILLING_CYCLES_PRIORITIES[a] - BILLING_CYCLES_PRIORITIES[b],
  ),
)
const leftBillingCycle = computed(() => sortedBillingCycles.value[0])
const rightBillingCycle = computed(() => sortedBillingCycles.value[1])

const isToggleActive = ref(props.modelValue === rightBillingCycle.value)

watch(isToggleActive, (newValue) => {
  if (newValue) {
    emit('update:modelValue', rightBillingCycle.value)
  } else {
    emit('update:modelValue', leftBillingCycle.value)
  }
})

watch(
  () => props.modelValue,
  (newValue) => {
    isToggleActive.value = newValue === rightBillingCycle.value
  },
)

onMounted(() => {
  if (props.modelValue === null) {
    emit('update:modelValue', rightBillingCycle.value)
  }
})
</script>
